export const CATEGORIES = [
  { slug: "property", label: "Property", icon: "Building2", live: true, to: "/",
    tagline: "Homes, apartments, villas & plots across India." },
  { slug: "motors", label: "Motors", icon: "Car", live: true, to: "/motors",
    tagline: "Buy & sell used and new cars from verified sellers." },
  { slug: "bikes", label: "Bikes", icon: "Bike", live: true, to: "/v/bikes",
    tagline: "Motorbikes, scooters & superbikes — verified deals." },
  { slug: "parts", label: "Parts", icon: "Wrench", live: true, to: "/v/parts",
    tagline: "Genuine mechanic parts & spares for cars and bikes." },
  { slug: "materials", label: "Building Materials", icon: "Hammer", live: true, to: "/v/materials",
    tagline: "Cement, steel, tiles & everything to build your home." },
];
